import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom'
import Aboutuslearners from '../Landing/Subcomponent/aboutuslearners';
import Aluminicompany from '../Landing/Subcomponent/aluminicompany';
import Whyedu from '../Landing/Subcomponent/whyedu';

import { faBell } from '@fortawesome/free-solid-svg-icons';

class Financial extends Component {
    render() {
        return (
            <div>
                <div aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><Link ><FontAwesomeIcon icon={faHome} />  &nbsp; HOME</Link></li>
                        <li class="breadcrumb-item active">Financial Statements Analysis Course</li>
                    </ol>
                </div>
                <section class="course-header bg-blue1" id="course-header">
                    <div class="row">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-5">
                            <h1>Financial Statements Analysis Course</h1>
                            <p>Learn to Read Financial Statements and Make Better Financial Decisions</p>
                            <br />
                            <div class="row">
                                <button class="pulse-button" type="button" data-toggle="modal" data-target="#myModalq" onclick="startvideo()"></button>
                                <p class="Watch-Intro">Watch Intro Video </p>
                            </div><br />
                            <div class="form-group">
                                <a href="#apply-now" class="btn btn-md enroll-btn" >Enroll Now </a>
                                <button type="button" class="btn btn-md download-bro-btn" data-toggle="modal" id="myBtn"
                                    data-target="#myModal" onclick="return gtag_report_conversion('<?php echo $baseurl;?>course/financial-statements-analysis-course');">Download
                                 brochure</button><br /><br /><br />
                            </div>
                        </div>
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-2"></div>
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-5">
                            <p>Jointly Delivered by </p>
                            <ul>
                                <li><img width="200px" src="/assets/images/epn.svg" alt="Plus Logo" /></li>
                                  &nbsp;&nbsp;&nbsp;&nbsp;  <li><img width="100px" height="75px;" src="/assets/images/icons/guru&jana.jpg" alt="Guru & Jana CA" /></li><br />
                            </ul>
                            <br />
                        </div>
                    </div>
                </section>

                <div class="course-main-contains def-z"  id="Description" >
                    <div class="card">
                        <div class="row contanint-display">
                            <div class="col-lg-4 col-xl-4 col-12 col-sm-12 col-md-4">    
                            <b>What's included :<br />
                            <i class="fa fa-mobile" ></i> &nbsp;&nbsp;Mobile Support</b>  
                            </div>
                            <div class="col-lg-4 col-xl-4 col-12 col-sm-12 col-md-4">    
                            <b><i class="fa fa-comments" ></i>&nbsp; Discussion Forum</b><br />
                            <b><i class="fa fa-certificate" ></i> &nbsp; Course Certificate</b>
                            </div>
                            <div class="col-lg-4 col-xl-4 col-12 col-sm-12 col-md-4"  >    
                            <b><i class="fa fa-question" ></i> &nbsp;&nbsp;&nbsp;Quiz</b><br />
                        
                            </div>
                        </div>
                    </div>
                </div>

                <section class="def-z">
                    <div class="header" id="myHeader">
                            <ul>
                                <li><a href="#Description">Description</a></li>
                                <li><a href="#Features">Features </a></li>
                                <li><a href="#Syllabus">Syllabus</a></li>            
                                <li><a href="#Outcomes">Learning Outcomes</a></li>           
                                <li><a href="#Reviews">Learner Review </a></li>          
                                <li><a href="#Instructor">About Instructor</a></li>         
                                <li class="btn-header cs-dx"><a href="#apply-now">Enroll Now</a></li>    
                            </ul>
                    </div>
                </section>

                <section class="course-description" id="course-description">
                     <br />    
                    <div class="row">
                        <div class="col-sm-12">
                            <h3 class="heading-tab">An Overview Of The Financial Statements Analysis Course</h3>
                            <p align="justify" id="Features">The Financial Statement Analysis Course is designed to provide a basic understanding of financial statements, with an emphasis being given to the balance sheet. However, the understanding of financial statements does not go beyond one's ability to recognize that accounting is more about measuring than about counting. The course will help you learn about the three measurement questions and the importance of a balance sheet.<br />
                                This Financial Statements Analysis Course in Pune is an online course which is accessible for PAN India audience. This course is certified by Edu Plus Now, Pune and the highly qualified faculty from Guru and Jana, Bangalore has curated the industry-oriented course according to the beginner level requirements of enrollees. The faculty who imparts the education for the course is a reputed and renowned Chartered Accountant. This course by Edu Plus Now is highly accredited & by far the best rated financial statements analysis courses in India.</p>
                            <br />
                        </div>
                  
                    </div>     
                    <div class="row">
                        <div class="col-sm-12">
                            <h3 class="heading-tab">Key Features Of The Financial Statements Analysis Course </h3>
                            <p align = "justify">
                            <ul class="highlight-ss">
                            <li> Guru and Jana as the knowledge partner</li>
                            <li> Mentorship by industry specialists</li>
                            <li> Seamless EMI options</li>
                            <li> Industry-oriented curriculum</li>
                            </ul>
                            </p>
                        </div>
                     

                        <div class="col-1"> </div>
                    </div> 
                    <br />
                    <div class="row">
                        <div class="col-sm-12"> 
                            <h3 class="heading-tab">Eligibility Criteria For Financial Statements Analysis Course  </h3>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-6">
                            <ul class="highlight-ss">
                            <li>	Commerce and business students who want a holistic understanding of accounting terms like the end product, financial statements, and not just how the end product is created through bookkeeping.</li>
                            <li>	Students interested in finance, accounts, and learning numbers and figures.</li>
                            <li>	Working managers who would like to read and decipher financial statements without learning the concept of bookkeeping.</li>
                            </ul>
                        </div>
                        <div class="col-sm-6">
                            <ul class="highlight-ss">
                            <li>		Investors who want to read and study their company’s annual reports and 10Ks.</li>
                            <li id="Syllabus">	Salaried employees from non-accounting/finance backgrounds who want to determine how their company is doing financially without having to study accounts and finances.</li>
                            <li>		People specialized in accounting and finance should NOT enrol themselves for the course.</li>
                            </ul>
                        </div>
                    </div>
                </section> 


                <section class="course-syllabus" id="course-syllabus">
                    <div class="row">
                        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-10" >
                        <h3> What Will You Learn In Financial Statements Analysis Training Course? </h3>
                                <br />
                                The course is divided in 5 sections and each section has a valuable and relevant lesson for
                                financial analysts in India. The sections are -
                                <div class="syl-bg">
                                <div id="de_syllabus">
                                    <div class="panel-group">
                                        <div class="panel panel-info">
                                            <div class="panel-heading" id="de_heading1" data-toggle="collapse"
                                                href="#de_syllabus1" aria-expanded="true" aria-controls="de_syllabus1">
                                                <h6 class="panel-title">
                                                    <i class="indicator fa fa-minus"></i> Section 1 
                                                </h6>
                                            </div>

                                            <div id="de_syllabus1" class="collapse show" aria-labelledby="de_heading1"
                                                data-parent="#de_syllabus">
                                                <div class="panel-body">
                                                    <ul class="syllabus-ul">
                                                        <li>Book of Accounts, P&L statement</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                       
                                        <div class="panel panel-info">
                                            <div class="panel-heading" id="de_heading2" data-toggle="collapse"
                                                href="#de_syllabus2" aria-expanded="true" aria-controls="de_syllabus2">
                                                <h6 class="panel-title">
                                                    <i class="indicator fa fa-minus"></i> Section 2
                                                </h6>
                                            </div>

                                            <div id="de_syllabus2" class="collapse show" aria-labelledby="de_heading2"
                                                data-parent="#de_syllabus">
                                                <div class="panel-body">
                                                    <ul class="syllabus-ul">
                                                        <li> Income Statement</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                     
                                        <div class="panel panel-info">
                                            <div class="panel-heading" id="de_heading3" data-toggle="collapse"
                                                href="#de_syllabus3" aria-expanded="true" aria-controls="de_syllabus3">
                                                <h6 class="panel-title">
                                                    <i class="indicator fa fa-minus"></i>Section 3
                                                </h6>
                                            </div>

                                            <div id="de_syllabus3" class="collapse show" aria-labelledby="de_heading3"
                                                data-parent="#de_syllabus">
                                                <div class="panel-body">
                                                    <ul class="syllabus-ul">
                                                        <li>Equity Position, Current and Non-current Liabilities</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                    
                                        <div class="panel panel-info">
                                            <div class="panel-heading" id="de_heading4" data-toggle="collapse"
                                                href="#de_syllabus4" aria-expanded="true" aria-controls="de_syllabus4">
                                                <h6 class="panel-title"><i class="indicator fa fa-minus"></i>Section 4
                                                </h6>
                                            </div>

                                            <div id="de_syllabus4" class="collapse show" aria-labelledby="de_heading4"
                                                data-parent="#de_syllabus">
                                                <div class="panel-body">
                                                    <ul class="syllabus-ul">
                                                        <li>Non-current Liabilities, Current and Non-current Assets</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="panel panel-info">
                                            <div class="panel-heading" id="de_heading5" data-toggle="collapse"
                                                href="#de_syllabus5" aria-expanded="true" aria-controls="de_syllabus5">
                                                <h6 class="panel-title">
                                                    <i class="indicator fa fa-minus" id="Outcomes"></i>
                                                    Section 5
                                                </h6>
                                            </div>

                                            <div id="de_syllabus5" class="collapse show" aria-labelledby="de_heading5"
                                                data-parent="#de_syllabus">
                                                <div class="panel-body">
                                                    <ul class="syllabus-ul">
                                                        <li>ROI, Ratios, Working Capital, Financial Health</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
            
                                    
                                    </div>
                                </div> 
                            </div>
                            </div>
                        </div> 
                    </section>

                    <section class="course-learning-outcome bg-secondary " id="course-learning-outcome">
                        <div class="row">
                            <div class="col-sm-6">
                                <h3>Learning Outcomes</h3>
                                <ul class="lo-ul">
                                <li>	You will be able to decode the different branches of accounting.</li>
                                <li>	You will be able to explore and learn items that are typically included in each of the financial statements along with their meanings.</li>
                                <li>	You will understand the purpose of financial statements (like income statement, statement of financial position, and cash flow statement).</li>
                                <li>	You will be able to interpret financial statements for decision-making purposes in businesses.</li>
                                <li>	You can recognize and understand the significance of several items that are a part of a balance sheet. </li>
                                <li>	You will be capable of explaining the broader purpose of financial statements.</li>
                                <li>	You will be aware of the role of accounting in producing the financial statements.</li>
                                <li>	You will be able to read and interpret balance sheets of companies that will intimate you on the company’s net worth and value.</li>
                                </ul>
                                <br />
                                <h3>Assessment</h3>
                                <div class="table-responsive course-batch-schedule"> 
                                    <div class="card">
                                        <table class="table">
                                            <thead>
                                                <tr class="text-center">
                                                    <th >Type</th>
                                                    <th >Weightage %</th>
                                                </tr>
                                            </thead>
                                            <tbody class="content-size">
                                                <tr>
                                                    <td >Content</td>
                                                    <td id="Reviews">100%</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <img src="/assets/images/icons/certificate1.png" alt="Financial Statements Analysis Course" />                          
                            </div>
                        </div>
                        <br /><br />
                    </section>

                    <Aboutuslearners />
                    <Aluminicompany />
                        <section class="courses-feesm">
                        <section class="course-fees" id="course-fees">
                        <div class="row box-sh" >
                            <div class="col-sm-12 col-lg-12	col-xl-5  pd-fee" >
                                   
                                    
                                    </div>
                                <div class="vertical-line-fee"> </div>
                                <div class="col-sm-12 col-lg-12 col-xl-6 pd-fee">
                                    <div class="row">
                                        <div class="col-sm-10"> <br /><br />
                                            <h5>Features</h5>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12 col-sm-12">
                                        <ul class="highlight-ss" >
                                            <li> Guru and Jana as the knowledge partner</li>
                                            <li> Mentorship by industry specialists</li>
                                            <li> Seamless EMI options</li>
                                            <li> Industry-oriented curriculum</li>
                                        </ul>
                                        </div>
                                        <p>{// eslint-disable-next-line
                                    }<marquee onmouseover="this.stop();" onmouseout="this.start();" class="marquee-enroll" >"If a group of four or more participants enroll with us, a concession of 10% will be awarded to each one of them. For more details Contact us."
                                    <a href="tel://8956167195"> &nbsp;&nbsp;<i class="fa fa-mobile" aria-hidden="true"></i> +91 8956167195</a></marquee>
                                    </p>   
                                    </div> 
                                    </div>
                            </div>
                        </section> 
                        </section> 

                        <Whyedu />
                        <section class="course-about-instructor bg-secondary " id="course-about-instructor">
                            <div class="row">
                                <div class="col-sm-12">
                                    <h3>About the Instructor</h3>
                                    <br />
                                    <div class="about-ist">
                                        <div class="card pd-abt-ist">
                                            <div class="social-instructor">
                                            <img   onerror="this.onerror=null;this.src='https://s3.ap-south-1.amazonaws.com/myeduplusnow/person/default_avatar.jpg';" alt="Guru Prasad" src="https://s3.ap-south-1.amazonaws.com/myeduplusnow/person/26_GuruPrasad.jpg" />
                                        </div>
                                        <div class="inst-details">
                                                <h3>Guru Prasad</h3>
                                                    <p>30 Years Of Experience</p>
                                                    <br />
                                                    <h4>Guru and Jana</h4>
                                                    <p align="justify">Guru is the Founding Partner and heads the Consulting Team and Indirect Tax Team at Guru and Jana. The firm has a unique way of life and character, which, led by Guru, leads to thought leadership, empowerment and action. A Chartered Accountant with a degree in law and commerce, Guru brings over 20 years of experience to the firm. With a calm business head, he specialises in business advisory services and heads the strategy and business development front of the firm. An alumnus of the Indian Institute of Management, he also holds a diploma in counseling. Guru has been a member of the Auditing Standards Board of ICAI and has authored seven technical guides on internal audit. He has published a book ‘Banter Beyond The Buck’ and is an avid global traveler and Tabla player. He represents India subcontinent in the HLBI Global Tech Group. He is also a Board Adviser to Vishwakarma University Pune [Autonomous].</p>
                                                    <br />
                                                    <ul class="course-about-ul">
                                                        <li>
                                                            <a href="https://www.facebook.com/guruprasad.makam" target="_blank"  rel="noreferrer">
                                                            <FontAwesomeIcon icon={faBell} />
                                                            </a>
                                                        </li>
                                                        <li >
                                                            <a href="https://www.linkedin.com/in/guru-prasad-58b9b913/ @guruprasadmakam" target="_blank"  rel="noreferrer" >
                                                            <FontAwesomeIcon icon={faBell} />
                                                            </a>
                                                        </li>
                                                        <li >
                                                            <a href="https://twitter.com/guruprasadmakam " target="_blank"  rel="noreferrer"  >
                                                            <FontAwesomeIcon icon={faBell} />
                                                            </a>
                                                        </li>
                                                        <li >{// eslint-disable-next-line
                                            }<a href="#"  target="_blank"  rel="noreferrer">
                                                        <FontAwesomeIcon icon={faBell} />
                                                            </a></li>
                                                    </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-12">
                                    <br />
                                    <br />
                                    <div class="about-ist">
                                        <div class="card pd-abt-ist">
                                            <div class="social-instructor">
                                                <img   onerror="this.onerror=null;this.src='https://s3.ap-south-1.amazonaws.com/myeduplusnow/person/default_avatar.jpg';" alt="Pankaj Mandhane" src="https://s3.ap-south-1.amazonaws.com/myeduplusnow/person/30_pankaj.jpg" />
                                            </div>
                                           <div class="inst-details">
                                               <h3>Pankaj Mandhane </h3>
                                                <p>18 Years Of Experience</p>
                                                <br />
                                                <h4>Guru and Jana</h4>
                                                <p align="justify">Pankaj is a Chartered Accountant who handles the Pune Branch operations of Guru and Jana. He has an experience of 18 years in taxation, consultancy and business structuring. He regularly writes in newspaper about direct & indirect tax. He has delivered lectures in many forums about impact on business of accounts, finance & taxation. He has given live TV interviews on many news channels about taxation and increase in job opportunities due to GST.</p>
                                                <br />
                                                <ul class="course-about-ul">
                                                <li >{// eslint-disable-next-line
                                            } <a href="#"   >
                                                    <FontAwesomeIcon icon={faBell} />
                                                    </a>
                                                </li>
                                                <li >{// eslint-disable-next-line
                                            }<a href="#"   >
                                                    <FontAwesomeIcon icon={faBell} />
                                                    </a>
                                                </li>
                                                <li >{// eslint-disable-next-line
                                            }<a href="#"   >
                                                    <FontAwesomeIcon icon={faBell} />
                                                    </a>
                                                </li>
                                                <li >{// eslint-disable-next-line
                                            }<a href="#"  target="">
                                                <FontAwesomeIcon icon={faBell} />
                                                    </a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                               </div>
                            </div>
                        </section>

                        <div class="modal fade" id="myModalq" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                            <div class="modal-dialog  modal-xl" role="document">
                                <div class="modal-content">
                                    <div class="modal-body">
                                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" onclick="stopvideo()">
                                        <span class="colse-icon" aria-hidden="true">&times;</span>
                                        </button>        
                                       
                                        <div class="embed-responsive embed-responsive-21by9">
                                        <video controls="true" class="embed-responsive-item" id="video">
                                            <source src="https://s3.ap-south-1.amazonaws.com/eduplusnowlive1/course/34/29/video/Introduction.mp4"  type="video/mp4" />
                                        </video>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="modal fade bd-example-modal-sm" id="myModal" role="dialog" >
                            <div class="modal-dialog modal-md">
                                 <div class="modal-content">
                                            <div class="modal-header" >
                                                <span class="close" id="close_form"
                                                       data-dismiss="modal">&times;</span>
                                                        <br />
                                            </div>
                                        <div class="modal-body" >
                                            <div class="panel panel-default paper-shadow box_detail">
                                                    <h5 class="text-center "> Download The Course Brochure </h5>
                                                <form method="post" class="form-row"  onsubmit="return validate()">

                                                        
                                                        <b>Your Name</b><input class="form-control" pattern="[A-Za-z ]{1,32}" type="text"
                                                            required="" autocomplete="on" name="name" id="name" />
                                                        <b>Your email</b><input class="form-control" type="email" required=""
                                                            autocomplete="on" name="emaill" id="emaill" />
                                                        <b>Your Contact No</b><input class="form-control" pattern="[7-9]{1}[0-9]{9}"
                                                            type="tel" required="" autocomplete="on" name="contactt" id="contactt" />
                                                        <input type="hidden" name="id" id="exd-course-name" value='<?php echo $words[0]; ?>' />
                                                        <input type="hidden" id="backurl" value="<?php echo $backurl?>" />
                                                        <br />
                                                        <div>
                                                            <div class="form-group">
                                                                <div  id="recaptcha" class="g-recaptcha"
                                                                    data-sitekey="6Lejh30UAAAAAPhZirvpXtobtIE80K7NUzsDqKjE"></div>
                                                                    <div id="captcha"></div>
                                                                </div>
                                                            </div>
                                                        
                                                        
                                                            <div class="mob_cb">
                                                                <div>
                                                                </div><br />                                                         
                                                                <button class="btn_1 rounded" type="button" onclick="getbroucher(<?php echo '\''.$filepath.'\'';?>)"  id="exd-download" >
                                                                    <i class="icon-download"></i> Brochure</button>
                                                            </div>
                                                 
                                                             <br />
                                                          
                                                </form>
                                            </div>
                                        </div>
                                 </div>
                            </div>
                        </div>
                        
   




            </div>
        )
    }
}

export default Financial;